import React from 'react'
import styled from 'styled-components'
import { RowFlexDiv, Icon } from './CommonStyle'
import { HelveticaNeueBold14 } from '../Common/Fonts'

const CreateButton = ({ NavbarMinified, title }) => {
  return (
    <RowFlexDiv
      width='100%'
      height='30px'
      gap='5px'
      justifyContent='center'
      outline='1px solid #6D0BF7'
      opacity={NavbarMinified ? '0' : '1'}
      backgroundColor='#6905F7'
      Cursor='pointer'
    >
      <Icon src='/images/navbar/plus-icon.svg' alt='assignments' />
      <HelveticaNeueBold14 white>{title}</HelveticaNeueBold14>
    </RowFlexDiv>
  )
}

export default CreateButton
